import { BottomSheetContent as L2RBottomsheetContent, styledForMobile } from "@l2r-front/l2r-ui"

export const SidebarContent = styledForMobile(L2RBottomsheetContent)(() => ({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100%",
    width: "100%",
}))